module.exports = __webpack_public_path__ + "static/img/sicoob.f9483793.svg";